import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { candidates, STAGES } from '../data/hrData';
import Avatar from './ui/Avatar';
import Badge from './ui/Badge';
import Modal from './ui/Modal';
import CandidateDetail from './CandidateDetail';

const stageColors = {
  Applied: 'bg-gray-100 border-gray-300',
  Screening: 'bg-blue-50 border-blue-200',
  Shortlisted: 'bg-purple-50 border-purple-200',
  Interview: 'bg-amber-50 border-amber-200',
  Offer: 'bg-emerald-50 border-emerald-200',
};
const stageDot = {
  Applied: 'bg-gray-400',
  Screening: 'bg-blue-500',
  Shortlisted: 'bg-purple-500',
  Interview: 'bg-amber-500',
  Offer: 'bg-emerald-500',
};

export function PipelineView() {
  const [selected, setSelected] = useState(null);

  return (
    <>
      <div className="overflow-x-auto pb-2">
        <div className="flex gap-4 min-w-max">
          {STAGES.map((stage, si) => {
            const cols = candidates.filter(c => c.stage === stage);
            return (
              <motion.div key={stage} initial={{ opacity: 1, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: si * 0.07 }}
                className={`w-56 rounded-xl border-2 ${stageColors[stage]} p-3 flex flex-col gap-2`}>
                <div className="flex items-center justify-between mb-1">
                  <div className="flex items-center gap-1.5">
                    <span className={`w-2 h-2 rounded-full ${stageDot[stage]}`} />
                    <span className="text-xs font-semibold text-gray-700">{stage}</span>
                  </div>
                  <span className="text-xs bg-white border border-gray-200 rounded-full px-2 py-0.5 font-medium text-gray-500">{cols.length}</span>
                </div>
                {cols.map((c, ci) => (
                  <motion.div key={c.id} initial={{ opacity: 1 }} animate={{ opacity: 1 }} transition={{ delay: ci * 0.04 }}
                    onClick={() => setSelected(c)}
                    className="bg-white rounded-lg border border-gray-200 p-3 cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
                    <div className="flex items-center gap-2 mb-1.5">
                      <Avatar src={c.avatar} name={c.name} size="sm" />
                      <div className="min-w-0">
                        <p className="text-xs font-semibold text-gray-900 truncate">{c.name}</p>
                        <p className="text-xs text-gray-500 truncate">{c.role}</p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-gray-400">{c.source}</span>
                      <span className="text-xs font-bold text-purple-600">{c.score}%</span>
                    </div>
                  </motion.div>
                ))}
                {cols.length === 0 && <p className="text-xs text-gray-400 text-center py-4">No candidates</p>}
              </motion.div>
            );
          })}
        </div>
      </div>
      <Modal open={!!selected} onClose={() => setSelected(null)} title="Candidate Profile" className="max-w-2xl">
        {selected && <CandidateDetail candidate={selected} onClose={() => setSelected(null)} />}
      </Modal>
    </>
  );
}

export default PipelineView;